import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "change-role"
};
var _hoisted_2 = {
  key: 0,
  class: "role-list"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = ["src"];
import { reactive, onMounted, inject } from 'vue';
import { getStore } from '@/util/store';

/* api */
import { getDiscussUsers } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'ChangeRole',
  props: {
    modelValue: {
      type: [Number, String],
      default: 0
    }
  },
  emits: ['update:modelValue', 'change'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 工具 */

    var discussId = inject('discussId');
    var emit = __emit;
    var state = reactive({
      currentRole: {},
      // 当前视角信息
      roleList: [],
      // 视角列表
      isOpen: false // 是否展开下拉
    });
    var defaultAvatar = require('@/assets/discuss/default-avatar.png');

    /* 事件 */
    var itemClick = function itemClick(item) {
      state.currentRole = item;
      state.isOpen = false;
      emit('update:modelValue', item.id);
      emit('change', item);
    };

    // 获取角色列表
    var getRoles = function getRoles() {
      var _getStore;
      var userId = (_getStore = getStore({
        name: 'userInfo'
      })) === null || _getStore === void 0 ? void 0 : _getStore.id;
      getDiscussUsers(discussId.value, userId).then(function (res) {
        if (res.data.code === 0) {
          var list = res.data.data || [];
          state.roleList = list.map(function (e) {
            return {
              id: e.userId,
              name: e.uname,
              head: e.avatar
            };
          });
          state.currentRole = state.roleList.find(function (e) {
            return e.id === userId;
          });
        }
      });
    };

    /* 钩子 */
    onMounted(function () {
      getRoles();
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("span", null, "视角切换", -1)), _createElementVNode("div", {
        class: "current-role",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return state.isOpen = !state.isOpen;
        })
      }, [_createElementVNode("span", null, _toDisplayString(state.currentRole.name), 1), _createVNode(_component_svg_icon, {
        class: "select",
        name: "select"
      })]), state.isOpen ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.roleList, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(["role-item", {
            'role-active': state.currentRole.id === item.id
          }]),
          onClick: function onClick($event) {
            return itemClick(item);
          }
        }, [_createElementVNode("div", null, [_createElementVNode("img", {
          src: item.head || _unref(defaultAvatar),
          alt: ""
        }, null, 8, _hoisted_4), _createElementVNode("span", null, _toDisplayString(item.name), 1)]), state.currentRole.id === item.id ? (_openBlock(), _createBlock(_component_svg_icon, {
          key: 0,
          name: "eye"
        })) : _createCommentVNode("", true)], 10, _hoisted_3);
      }), 128))])) : _createCommentVNode("", true)]);
    };
  }
};